import { AdminBaseRoles } from '@deltek/specification-client/core/Configurations/Authorization'
import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import { lazy } from 'react'
import { BPMRoutes } from './bpmRoutes'
import { ContactsPageRoutes } from './contactsPageRoutes'
import { ProjectsPageRoutes } from './projectsPageRoutes'
import { StudioPageRoutes } from './studioPageRoutes'
import { WorkflowPageRoutes } from './workflowPageRoutes'
const ProductListingDialogLazy = lazy(
    () => import('pages/components/ProductListingDialog')
)
const ContactsPageLazy = lazy(() => import('pages/ContactsPage'))
const ProjectsPageLazy = lazy(() => import('pages/ProjectsPage'))
const PrintPreviewPageLazy = lazy(
    () => import('pages/PreviewPage/PrintPreviewPage')
)
const BPMPageLazy = lazy(() => import('pages/MainPage'))
const DashboardPageLazy = lazy(() => import('pages/DashboardPage'))

const StudioPageLazy = lazy(() => import('pages/StudioPage'))

const WorkItemPageLazy = lazy(() => import('pages/WorkItemManagementPage'))

const UserCreationPageLazy = lazy(
    () => import('pages/SettingsPage/UserCreationPage')
)
const UserManagementPageLazy = lazy(
    () => import('pages/SettingsPage/UserManagementPage')
)
const AccountPageLazy = lazy(() => import('pages/SettingsPage/AccountPage'))

export const Routes: RouteDictionary = {
    '/': {
        redirect: '/projects',
    },
    '/dashboard': {
        name: 'Dashboard',
        component: DashboardPageLazy,
    },
    '/products': {
        name: 'Products Listing Dialog',
        component: ProductListingDialogLazy,
    },
    '/projects': {
        name: 'Projects Page',
        component: ProjectsPageLazy,
        exact: false,
        children: ProjectsPageRoutes,
    },
    '/contacts': {
        name: 'Contacts',
        component: ContactsPageLazy,
        exact: false,
        children: ContactsPageRoutes,
        componentProps: {
            title: 'Contacts',
        },
    },
    '/account': {
        name: 'Account Settings',
        component: AccountPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/users': {
        name: 'Manage Users',
        component: UserManagementPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/user-setup': {
        name: 'User',
        component: UserCreationPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/user-setup/:userId': {
        name: 'User',
        component: UserCreationPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/preview/:projectId/workspace/preview/:elementId/preview/:familyNodeId': {
        name: 'Preview',
        component: PrintPreviewPageLazy,
    },

    '/preview/:projectId/elementLibrary/preview/:elementId/preview/:familyNodeId': {
        name: 'Preview',
        component: PrintPreviewPageLazy,
    },
    '/preview/:projectId/workspace/preview/:elementId/preview/:nodeId/preview/:familyNodeId': {
        name: 'Preview',
        component: PrintPreviewPageLazy,
    },

    '/master': {
        name: 'Office Master Import',
        component: StudioPageLazy,
        exact: false,
        children: StudioPageRoutes,
    },
    '/workflow': {
        name: 'WorkItem Management',
        component: WorkItemPageLazy,
        exact: false,
        children: WorkflowPageRoutes,
    },
    '/bpm': {
        name: 'Manufacturer Client',
        component: BPMPageLazy,
        exact: false,
        children: BPMRoutes,
    },
}
